import React from 'react'
import dividerBlack from '../imgs/dividerBlack.svg'
import dividerGreen from '../imgs/dividerGreen.svg'
import '../css/divider.css'

const Divider = () => {
  return (
    <div className="sectionDivider">
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
        <img src={dividerGreen} alt="divider" className="divider" /> 
        <img src={dividerBlack} alt="divider" className="divider" />
    </div>
  )
}

export default Divider